// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* styles.css */

.card-front, .card-back {
  position: absolute; /* Ensure elements are positioned on top of each other */
  width: 100%; /* Full width of the flip card */
  height: 100%; /* Full height of the flip card */
  backface-visibility: hidden; /* Hide the back face when flipped */
  -webkit-backface-visibility: hidden; /* For older browsers */
  display: flex;
  align-items: center; /* Center content vertically */
  justify-content: center; /* Center content horizontally */
  transform: rotateX(0);
}

.card-front {
  background-color: white; /* Front side background color */
  z-index: 2; /* Ensure front side is above the back side */
}

.card-back {
  color: black; /* White text on the back */
  transform: rotateY(180deg); /* Rotate the back side */
}

.flip-card {
  box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2);
  transition: 0.3s;
  width: 40%;
  display: inline-block;
  vertical-align: middle;
  margin: 3% 5%;
  background-color: white;
  border-radius: 20px;
  height: 200px;
  perspective: 1000px; /* For 3D effect */
}

.flip-card-inner {
  position: relative;
  width: 100%;
  height: 100%;
  text-align: center;
  transition: transform 0.8s;
  transform-style: preserve-3d; /* Preserve 3D transformations */
}

.flip-card:hover .flip-card-inner {
  transform: rotateY(180deg); /* Flip on hover */
}

.card-row {
  margin: 0 auto;
  display: flex;
  flex-wrap: wrap; /* Allow wrapping of cards */
}

.card:hover {
  box-shadow: 0 8px 16px 0 rgba(0,0,0,0.2);
}
`, "",{"version":3,"sources":["webpack://./src/components/Card.css"],"names":[],"mappings":"AAAA,eAAe;;AAEf;EACE,kBAAkB,EAAE,wDAAwD;EAC5E,WAAW,EAAE,gCAAgC;EAC7C,YAAY,EAAE,iCAAiC;EAC/C,2BAA2B,EAAE,oCAAoC;EACjE,mCAAmC,EAAE,uBAAuB;EAC5D,aAAa;EACb,mBAAmB,EAAE,8BAA8B;EACnD,uBAAuB,EAAE,gCAAgC;EACzD,qBAAqB;AACvB;;AAEA;EACE,uBAAuB,EAAE,gCAAgC;EACzD,UAAU,EAAE,6CAA6C;AAC3D;;AAEA;EACE,YAAY,EAAE,2BAA2B;EACzC,0BAA0B,EAAE,yBAAyB;AACvD;;AAEA;EACE,uCAAuC;EACvC,gBAAgB;EAChB,UAAU;EACV,qBAAqB;EACrB,sBAAsB;EACtB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,mBAAmB,EAAE,kBAAkB;AACzC;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,0BAA0B;EAC1B,4BAA4B,EAAE,gCAAgC;AAChE;;AAEA;EACE,0BAA0B,EAAE,kBAAkB;AAChD;;AAEA;EACE,cAAc;EACd,aAAa;EACb,eAAe,EAAE,4BAA4B;AAC/C;;AAEA;EACE,wCAAwC;AAC1C","sourcesContent":["/* styles.css */\n\n.card-front, .card-back {\n  position: absolute; /* Ensure elements are positioned on top of each other */\n  width: 100%; /* Full width of the flip card */\n  height: 100%; /* Full height of the flip card */\n  backface-visibility: hidden; /* Hide the back face when flipped */\n  -webkit-backface-visibility: hidden; /* For older browsers */\n  display: flex;\n  align-items: center; /* Center content vertically */\n  justify-content: center; /* Center content horizontally */\n  transform: rotateX(0);\n}\n\n.card-front {\n  background-color: white; /* Front side background color */\n  z-index: 2; /* Ensure front side is above the back side */\n}\n\n.card-back {\n  color: black; /* White text on the back */\n  transform: rotateY(180deg); /* Rotate the back side */\n}\n\n.flip-card {\n  box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2);\n  transition: 0.3s;\n  width: 40%;\n  display: inline-block;\n  vertical-align: middle;\n  margin: 3% 5%;\n  background-color: white;\n  border-radius: 20px;\n  height: 200px;\n  perspective: 1000px; /* For 3D effect */\n}\n\n.flip-card-inner {\n  position: relative;\n  width: 100%;\n  height: 100%;\n  text-align: center;\n  transition: transform 0.8s;\n  transform-style: preserve-3d; /* Preserve 3D transformations */\n}\n\n.flip-card:hover .flip-card-inner {\n  transform: rotateY(180deg); /* Flip on hover */\n}\n\n.card-row {\n  margin: 0 auto;\n  display: flex;\n  flex-wrap: wrap; /* Allow wrapping of cards */\n}\n\n.card:hover {\n  box-shadow: 0 8px 16px 0 rgba(0,0,0,0.2);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
